import React from 'react';
import { JourneyNoCompraController } from '.';
import { MapGeneralController } from 'src/feature-app';

/**
 * Este componente está creado únicamente para que JourneyNoCompraController tenga acceso a las variables de MapGeneralController.
 */
export const JourneyNoCompraWrapper = () => {
	return (
		<MapGeneralController>
			<JourneyNoCompraController />
		</MapGeneralController>
	);
};
